<template>
  <div>
    <div class="managementvideo">
      <div class="header_tabs">
        草稿箱
      </div>
      <div class="manlistvideo" v-if="videoList.length > 0">
        <div class="itemvideo u-flex" v-for="(item,index) in videoList" :key="index">
          <div class="cntvideoimg">
            <img style="width: 166px; height: 200px; border-radius: 8px; background-color: darkgrey;" :src="imgsrc + item.coverImg" alt=""
              srcset="">
          </div>
          <div class="cntright" v-if="item.createTime">
           <div class="myfontexp">
              <input :id="item.createTime +'exp'" class="exp"  type="checkbox">
                  <div class="text">
                      <label class="btn" :for="item.createTime +'exp'"></label>
                      {{item.videoContent}}
                  </div>
           </div>
            <div class="videoupdatetime" >
              {{fifTime(item.createTime)}}
            </div>
            <div class="u-flex">
              <div class="videoerrbtn u-flex u-flex-items-center u-flex-center"  @click="navrouter(item)"  v-if="videostatus ==3">
                <img src="/static/center/edit.png" style="margin-right: 4px;" alt="" srcset="">  重新编辑
              </div>
              <div class="videoerrbtn nobg u-flex u-flex-items-center u-flex-center" @click="delVideoId(item)">
                <img src="/static/center/caogao.png" style="margin-right: 4px;" alt="" srcset="">  删除作品
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="emitdata">
          <img  style="width: 300px;height: 150px;" src="/static/person/buy_emit.png" alt="">
          <div class="eemit_txt">
              暂无草稿数据
          </div>
      </div>
    </div>
  </div>

</template>

<script>
  import ROOTURLS from '@/api/lz.js'
  import moment from 'moment'
  import {
    videoDraftlist,
    videoDraftdelete,
    publishList,
    videoDraftDel
  } from '@/api/video.js'
  export default {
    data() {
      return {
        imgsrc:'',
        activeName: '',
        videostatus:3,
        videoList:[],
      }
    },
    created() {
      this.initData();
      this.imgsrc = ROOTURLS.ImgpagaUrl
    },
    methods: {
      // 过滤时间
     fifTime(time){
       if(time)
     	return moment.unix(time).format('YYYY年MM月DD日 HH:mm')
     },
      initData(){
        // 查询草稿箱列表
        videoDraftlist({
          draftState:0,
          page:1,
          limit:100,
        }).then(res=>{
          console.log('草稿箱列表',res);
          if(res.data.code ==200){
            this.videoList = res.data.data.list
          }
        })
      },
      // 编辑视频
      navrouter(item){
        localStorage.setItem('editVideInfo',JSON.stringify(item))
        this.$emit('editvideo',-1);
      },
      // 删除视频
      delVideoId(item){
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         console.log('删除成功');
         videoDraftDel({
           draftId: item.draftId,
         }).then(res => {
           if (res.data.code == 200) {
             this.$message.success('删除成功');
             this.initData(this.activeName)
           }
         })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/style/flex.scss';
  .emitdata{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    min-height: 30vh;
    flex-direction: column;
    .eemit_txt{
      margin-top: 18px;
      font-size: 16px;
      color: #666;
    }
  }
  .managementvideo {
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
    width: calc(1200px - 202px);
    box-sizing: border-box;
    height: calc(100vh - 130px);
    overflow-y: scroll;
    .delvideo{
      margin-top: 12px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ED1010;
      img{
        width: 16px;
        height: 16px;
      }
    }
    .manlistvideo {
      padding: 0 24px;
      .itemvideo {
        margin-bottom: 24px;
        .cntright{
          .myfontexp{
            display: flex;
            overflow: hidden;
            .wrapper {
              display: flex;
              margin: 50px auto;
              width: 800px;
              overflow: hidden;
            /*   resize: horizontal; */
              border-radius: 8px;
              padding: 15px ;
            }
            .text {
              font-size: 16px;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: justify;
              white-space: normal;
              word-break: break-all;
              word-wrap: break-word;
              /* display: flex; */
            /*   display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical; */
              position: relative;
              line-height: 1.36rem;
              max-height:3em;
              color: #333;
              transition: .3s max-height;
            }
            .text::before {
              content: '';
              height: calc(100% - 26px);
              float: right;
            }
            .text::after {
              content: '';
              width: 999vw;
              height: 999vw;
              position: absolute;
              box-shadow: inset calc(100px - 999vw) calc(30px - 999vw) 0 0 #fff;
                margin-left: -100px;
            }
            .btn{
              position: relative;
              float: right;
              clear: both;
              margin-left: 20px;
              font-size: 16px;
              padding: 0 8px;
              // background: #3F51B5;
              line-height: 24px;
              border-radius: 4px;
              color:  #333;
              cursor: pointer;
              /* margin-top: -30px; */
            }
            .btn::after{
              content:'展开'
            }
            .exp{
              display: none;
            }
            .exp:checked+.text{
              max-height: none;
            }
            .exp:checked+.text::after{
              visibility: hidden;
            }
            .exp:checked+.text .btn::before{
              visibility: hidden;
            }
            .exp:checked+.text .btn::after{
              content:'收起'
            }
            .btn::before{
              content: '...';
              position: absolute;
              left: -5px;
              color: #333;
              transform: translateX(-100%)
            }
          }
          .videoerrbtn{
            margin-top: 40px;
            width: 98px;
            cursor: pointer;
            height: 36px;
            background: #721EDC;
            border-radius: 4px;
            text-align: center;
            line-height: 36px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            img{
              width: 16px;
              height: 16px;
            }
          }
          .nobg{
            background: #F7F8FA;
            margin-left: 24px;
            border: 1px solid #999999;
            color: #333;
          }
          .videoerr{
            margin-top: 12px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ED1010;
          }
          .videoupdatetime{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
          }
          .status_look{
            margin: 30px 0 10px;
            .statusvalue{
              margin-right: 22px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              img{
                margin-right: 2px;
                width: 13px;
                height: 12px;
              }
            }
          }
          .vtitle{
            margin-top: 6px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
        }
        .cntvideoimg{
          position: relative;
          margin-right: 12px;
          .pass{
            background-color: #7FE14D;
          }
          .awit{
            background-color: #1076E9;
          }
          .error{
            background-color: #ED1010;
          }
          .tabstatus {
            position: absolute;
            top: 12px;
            border-radius: 0 15px 15px 0;
            left: 0;
            width: 52px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
          }

          .vtimestatus {
            position: absolute;
            bottom: 6px;
            right: 8px;
            color: #FFFFFF;
            font-size: 12px;
          }
        }

      }
    }

    .header_tabs {
      margin:24px;
      font-size: 20px;
      padding-bottom: 12px;
      font-weight: 600;
      margin-bottom: 24px;
      border-bottom: 1px solid rgba(0,0,0,.1);
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/template/centerfraft.vue